import React, {useState} from 'react';
import warning_triangle from "../images/warning_triangle.svg";
import close_icon from "../images/close_icon.svg";
import { motion } from "framer-motion";
const CoreWarning = () => {

    const [isClosed, setIsClosed] = useState(false);
    return (
        <div className={`core_warning_fixed ${isClosed ? 'closed' : ''}`}>
            <img src = {warning_triangle} alt = ""/>
            Information presented in the Core section is illustrative and intended to outline Undura’s development
            direction.Final architecture, features, and regulatory processes may change to align with supervisory
            requirements, applicable laws, and ethical standards.
            <img src = {close_icon} alt = "" className = "close_icon" onClick={() => setIsClosed(true)}/>
        </div>
    );
};

export default CoreWarning;